export type BboxInput =
  | { x0: number; y0: number; x1: number; y1: number }
  | number[]
  | { bbox: number[] }
  | null

export function normalizeBbox(
  bbox: BboxInput | undefined,
): { x0: number; y0: number; x1: number; y1: number } | null {
  if (!bbox) return null
  if (Array.isArray(bbox)) {
    if (bbox.length < 4) return null
    return { x0: bbox[0]!, y0: bbox[1]!, x1: bbox[2]!, y1: bbox[3]! }
  }
  if ('bbox' in bbox && Array.isArray(bbox.bbox) && bbox.bbox.length >= 4) {
    return { x0: bbox.bbox[0]!, y0: bbox.bbox[1]!, x1: bbox.bbox[2]!, y1: bbox.bbox[3]! }
  }
  if ('x0' in bbox && 'y0' in bbox && 'x1' in bbox && 'y1' in bbox) {
    return bbox
  }
  return null
}

/** PyMuPDF top-left (y-down) → PDF user-space rect [x0, y0, x1, y1] (y-up). */
export function pymupdfBboxToPdfRect(
  bbox: { x0: number; y0: number; x1: number; y1: number },
  pageHeight: number,
): [number, number, number, number] {
  const pdfY0 = pageHeight - bbox.y1
  const pdfY1 = pageHeight - bbox.y0
  return [bbox.x0, pdfY0, bbox.x1, pdfY1]
}

export function viewportRectFromConverted(
  converted: number[],
): { left: number; top: number; width: number; height: number } {
  const left = Math.min(converted[0]!, converted[2]!)
  const top = Math.min(converted[1]!, converted[3]!)
  const width = Math.abs(converted[0]! - converted[2]!)
  const height = Math.abs(converted[1]! - converted[3]!)
  return { left, top, width, height }
}

export function rectsOverlap(
  a: { left: number; top: number; width: number; height: number },
  b: { left: number; top: number; width: number; height: number },
): boolean {
  return (
    a.left < b.left + b.width &&
    a.left + a.width > b.left &&
    a.top < b.top + b.height &&
    a.top + a.height > b.top
  )
}

export function spanViewportRect(
  span: HTMLElement,
): { left: number; top: number; width: number; height: number } {
  return {
    left: parseFloat(span.style.left) || 0,
    top: parseFloat(span.style.top) || 0,
    width: parseFloat(span.style.width) || 0,
    height: parseFloat(span.style.height) || 0,
  }
}
